import { Component, OnInit, OnChanges, Input } from '@angular/core';
import { DealStepEnum, DealStatusEnum, ViewModeEnum, AlertDialogTypeEnum, AlertDialogConfirmTypeEnum } from '../../../_enums/_index';
import { DealsWizardModel, DealModel, GetDealsRequestModel, DealCustomModel, DealPrintPreviewRequest } from '../../../_models/_index';
import { DealService } from '../../../services/deal.service';
import { GeneralService } from '../../../services/general.service';
import { RequestManagementService } from '../../../services/request-management.service';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { AlertDialogComponent } from '../../alert-dialog/alert-dialog.component';


@Component({
    selector: 'app-deals-grid',
    templateUrl: './deals-grid.component.html',
    styleUrls: ['./deals-grid.component.css']
})
export class DealsGridComponent implements OnInit {
    deals: DealCustomModel[];
    request: GetDealsRequestModel;
    cols: any[];
    loading: boolean;
    dealPrintPreviewRequest: DealPrintPreviewRequest;

    constructor(
        private dealsService: DealService,
        private requestManagementService: RequestManagementService,
        private dialog: MatDialog,
        private generalService: GeneralService) {
        this.deals = [];
        this.request = new GetDealsRequestModel();
        this.request.startDate = new Date();
        this.request.endDate = new Date();
        this.request.startDate.setDate(this.request.startDate.getDate() - 14);
        this.request.displayOnlyUncanceled = true;
    }

    ngOnInit() {
        this.initColumns();
        this.loadDeals();
    }
    

    initColumns()
    {
        this.cols = [
            { field: 'id', id: 'id', dealKey: 'dealKey', sortable: "true", header: "מספר הסכם", formatCell: "link", url: '/home/deal-wizard', display: 'table-cell'},
            { field: 'companyName', header: "שם לקוח", formatCell: "none", sortable: "true", display: 'table-cell'},
            { field: 'trialDurationDays', header: "תקופת זמן", formatCell: "none", sortable: "true", display: 'table-cell' },
            { field: 'trialDurationMinutes', header: "דקות שהוגדרו", formatCell: "none", sortable: "true", display: 'table-cell'},
            { field: 'createDate', header: "תאריך יצירה", formatCell: "dateTime", sortable: "true", display: 'table-cell' },

            { field: 'signedDate', header: "תאריך חתימה", formatCell: "dateTime", sortable: "true", display: 'table-cell'},
            { field: 'lastUpdate', header: "ת.עידכון אחרון", formatCell: "dateTime", sortable: "true", display: 'table-cell'},
            { field: 'statusDescription', header: "סטטוס", formatCell: "none", sortable: "true", display: 'table-cell'},
            { field: 'creditCardToken', header: "טוקן", formatCell: "none", sortable: "true", display: 'table-cell'},
            { field: 'pageNumber', header: "עמוד", formatCell: "none", sortable: "true", display: 'table-cell' },
            { field: 'sellerName', header: "מכירות", formatCell: "none", sortable: "true", display: 'table-cell' },
            { field: 'phoneNumber', header: "טלפון", formatCell: "none", sortable: "true", display: 'none' },
            { field: 'email', header: "מייל", formatCell: "none", sortable: "true", display: 'none' },
            { field: 'contactName', header: "שם המזמין", formatCell: "none", sortable: "true", display: 'none' },
            { field: 'mobileNumber', header: "נייד", formatCell: "none", sortable: "true", display: 'none' },
            { field: 'isTrial', header: "תקופת ניסיון", formatCell: "checkbox", sortable: "false", display: 'table-cell', isSortableHidden: "true" },
            { field: 'isSignedFromMobile', header: "נחתם ממובייל", formatCell: "checkbox", sortable: "false", display: 'table-cell', isSortableHidden: "true" },
            { field: 'statusID', header: "סטטוס", formatCell: "none", sortable: "true", display: 'none' },
            { field: 'serviceTypeDesc', header: "סוג", formatCell: "none", sortable: "true", display: 'table-cell' },

            
        ];
    }

    loadDeals()
    {
        this.loading = true;
        this.dealsService.getDeals(this.request).then(result => {
            this.deals = result;
            this.loading = false;
        });
    }

    createReport() {
        window.location.assign(this.requestManagementService.getBaseUrl()+ "deals/getDeals2Excel?filter=" + JSON.stringify(this.request));
    }  

    dealPrintPreview(deal: DealModel)
    {
        this.dealPrintPreviewRequest = new DealPrintPreviewRequest();
        this.dealPrintPreviewRequest.dealID = deal.id;
        this.dealPrintPreviewRequest.dealKey = deal.dealKey;
        this.dealPrintPreviewRequest.companyName = deal.companyName;
        this.dealPrintPreviewRequest.serviceTypeID = deal.serviceTypeID;
        window.location.assign(this.requestManagementService.getBaseUrl() + "deals/createDealPDF2PreviewByDealKey?filter=" + JSON.stringify(this.dealPrintPreviewRequest));
    }

    getYesNoDescription(data: boolean)
    {
        if (data)
            return 'כן';
        else return '';
    }

    sendPDF(deal:DealModel) {
        if (deal.statusID == DealStatusEnum.Signed) {
            this.generalService.showConfirmDialog("האם אתה בטוח שברצונך לשלוח חוזה(PDF) ללקוח " + (deal.companyName ? deal.companyName : deal.id.toString()) + "?", AlertDialogConfirmTypeEnum.YesNo)
                .then(result => {
                    if (result) {
                        this.dealsService.sendDealPDF(deal.dealKey, deal.email, deal.companyName,deal.serviceTypeID).then(result => {
                            if (result) {

                                this.generalService.showSnackBar("שליחה בוצעה בהצלחה!");
                            }
                            else {
                                this.generalService.showSnackBar("שגיאה-פנה למנהל המערכת!");
                            }
                        });
                    }
                    else {
                        this.generalService.showSnackBar("פעולה בוטלה");
                    }
                });
        }
    }

    emailSendDeal(deal: DealModel)
    {
        this.generalService.showConfirmDialog("האם אתה בטוח שברצונך לשלוח חוזה(לינק) ללקוח " + (deal.companyName?deal.companyName:deal.id) + "?", AlertDialogConfirmTypeEnum.YesNo)
            .then(result => {
                if (result) {
                    this.dealsService.emailSendDeal(deal).then(res => {
                        if (res) {

                            this.generalService.showSnackBar("שליחה בוצעה בהצלחה!");
                        }
                        else {
                            this.generalService.showSnackBar("שגיאה-פנה למנהל המערכת!");
                        }
                    });
                }
                else {
                    this.generalService.showSnackBar("פעולה בוטלה");
                }
            });
    }

    emailSendPayment(deal: DealModel) {


        this.dealsService.emailSendPayment(deal).then(res => {
            if (res) {

                this.generalService.showSnackBar("שליחה בוצעה בהצלחה!");
            }
            else {
                this.generalService.showSnackBar("שגיאה-פנה למנהל המערכת!");
            }
        });
    }

    cancelDeal(deal: DealModel) {
        let dialogRef = this.dialog.open(AlertDialogComponent);
        dialogRef.disableClose = true;
        dialogRef.componentInstance.message = "האם אתה בטוח שברצונך לבטל חוזה עבור " + deal.companyName + "?";
        dialogRef.componentInstance.alertDialogType = AlertDialogTypeEnum.Confirm;
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.dealsService.cancelDeal(deal).then(res => {
                    if (res) {
                        let copy = Object.assign([], this.deals);
                        copy.splice(this.deals.findIndex(c => c.id == deal.id), 1,res);
                        this.deals = copy;
                        this.generalService.showSnackBar("חוזה בוטל בהצלחה!");
                    }
                });
            }
            else {
                this.generalService.showSnackBar("מחיקה בוטלה");
            }
        });
    }

    duplicateDeal(deal: DealModel) {
        this.generalService.showConfirmDialog("האם אתה בטוח שברצונך לשכפל חוזה עבור " + deal.companyName + "?", AlertDialogConfirmTypeEnum.YesNo)
        .then(result => {
            if (result) {
                this.dealsService.duplicateDeal(deal.id).then(res => {
                    if (res) {
                        let copy = Object.assign([], this.deals);
                        copy.splice(this.deals.findIndex(c => c.id == deal.id), 1, res);
                        this.deals = copy;
                        this.generalService.showSnackBar("חוזה שוכפל בהצלחה!");
                    }
                });
            }
            else {
                this.generalService.showSnackBar("פעולה בוטלה");
            }
        });
    }

    duplicateSignedDeal(deal: DealModel) {
        this.generalService.showConfirmDialog("האם אתה בטוח שברצונך לשכפל חוזה עבור " + deal.companyName + "?", AlertDialogConfirmTypeEnum.YesNo)
            .then(result => {
                if (result) {
                    this.dealsService.duplicateSignedDeal(deal.id).then(res => {
                        if (res) {
                            //let copy = Object.assign([], this.deals);
                            //copy.splice(this.deals.findIndex(c => c.id == deal.id), 1, res);
                            //this.deals = copy;
                            this.loadDeals();
                            this.generalService.showSnackBar("חוזה שוכפל בהצלחה!");
                        }
                    });
                }
                else {
                    this.generalService.showSnackBar("פעולה בוטלה");
                }
            });
    }


}



// WEBPACK FOOTER //
// ./src/app/components/deals/deals-grid/deals-grid.component.ts